import { PaletteOptions } from '@mui/material';

// Ankr theme palette
export const darkPalette = {
  mode: 'dark',

  primary: {
    main: '#5A87F2',
    dark: '#2A64EE',
    light: '#E1E9FD',
    contrastText: '#ffffff',
  },

  secondary: {
    main: '#FFFFFF',
    dark: '#42464F',
    light: '#42464F',
    contrastText: '#82899A',
  },

  info: {
    main: '#FFFFFF',
    dark: '#42464F',
    light: '#42464F',
    contrastText: '#5A87F2',
  },

  error: {
    main: '#EC5478',
    dark: '#C8294E',
    light: '#350C15',
    contrastText: '#FFFFFF',
  },

  warning: {
    main: '#F0B358',
    dark: '#DCA451',
    light: '#554D42',
    contrastText: '#1F2226',
  },

  success: {
    main: '#4BC99B',
    dark: '#37B788',
    light: '#0F3224',
    contrastText: '#FFFFFF',
  },

  highlight: {
    main: '#F4E9D0',
    dark: '#FFA030',
  },

  background: {
    default: '#1F2226',
    paper: '#2E343C',
  },

  grey: {
    100: '#42464F',
    200: '#535863',
    300: '#BFC6D0',
    400: '#A7AFC0',
    500: '#9AA1B0',
    600: '#82899A',
    700: '#585E6B',
    800: '#9AA1B0',
    900: '#FFFFFF',
  },

  link: {
    main: '#5A87F2',
  },

  yellow: {
    main: '#FFD11A',
    dark: '#F3C200',
    light: '#3F3200',
  },

  teal: {
    main: '#54E1E1',
    dark: '#43C9C9',
    light: '#093333',
  },

  indigo: {
    main: '#6C6BDB',
    dark: '#5D5BBD',
    light: '#0B0B2E',
  },

  purple: {
    main: '#B967E2',
    dark: '#A059C4',
    light: '#23092F',
  },

  text: {
    primary: '#fff',
    secondary: '#82899A',
    disabled: '#A7AFC0',
  },

  divider: '#42464F',

  common: {
    black: '#000000',
    white: '#ffffff',
  },
} satisfies PaletteOptions;
